import React, { useState } from 'react';
import { Building2, Globe, Clock, Users, Plus, Trash2, Check, ArrowRight, ArrowLeft, Shield } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
export function OnboardingPage() {
  const navigate = useNavigate();
  const [step, setStep] = useState(1);
  const [departments, setDepartments] = useState(['Engineering', 'Sales', 'Marketing']);
  const [newDept, setNewDept] = useState('');
  const [invites, setInvites] = useState([{
    email: 'sarah@acme.com',
    role: 'Manager'
  }, {
    email: 'mike@acme.com',
    role: 'Traveler'
  }]);
  const [newInvite, setNewInvite] = useState({
    email: '',
    role: 'Traveler'
  });
  const handleAddDept = () => {
    if (newDept && !departments.includes(newDept)) {
      setDepartments([...departments, newDept]);
      setNewDept('');
    }
  };
  const handleAddInvite = () => {
    if (newInvite.email) {
      setInvites([...invites, newInvite]);
      setNewInvite({
        email: '',
        role: 'Traveler'
      });
    }
  };
  const handleComplete = () => {
    // In a real app, this would save all onboarding data
    navigate('/');
  };
  return <div className="max-w-4xl mx-auto py-8" data-id="element-1781">
      <div className="mb-8 text-center" data-id="element-1782">
        <h1 className="text-3xl font-bold text-slate-900" data-id="element-1783">
          Welcome to Super International Travels!
        </h1>
        <p className="mt-2 text-slate-500" data-id="element-1784">
          Let's get your organization set up in a few simple steps.
        </p>
      </div>

      {/* Progress Steps */}
      <div className="mb-10" data-id="element-1785">
        <div className="flex items-center justify-between relative max-w-2xl mx-auto" data-id="element-1786">
          <div className="absolute left-0 top-1/2 h-0.5 w-full -translate-y-1/2 bg-slate-200 -z-10" data-id="element-1787"></div>

          {[{
          num: 1,
          label: 'Organization'
        }, {
          num: 2,
          label: 'Departments'
        }, {
          num: 3,
          label: 'Policies'
        }, {
          num: 4,
          label: 'Team'
        }].map(s => <div key={s.num} className="flex flex-col items-center bg-slate-50 px-2" data-id="element-1788">
              <div className={`flex h-10 w-10 items-center justify-center rounded-full border-2 transition-colors ${step > s.num ? 'bg-emerald-500 border-emerald-500 text-white' : step === s.num ? 'bg-blue-600 border-blue-600 text-white' : 'bg-white border-slate-300 text-slate-400'}`} data-id="element-1789">
                {step > s.num ? <Check className="h-6 w-6" data-id="element-1790" /> : s.num}
              </div>
              <span className={`mt-2 text-xs font-medium ${step === s.num ? 'text-blue-600' : 'text-slate-500'}`} data-id="element-1791">
                {s.label}
              </span>
            </div>)}
        </div>
      </div>

      <div className="bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden" data-id="element-1792">
        <div className="p-8" data-id="element-1793">
          {step === 1 && <div className="space-y-6 animate-in fade-in slide-in-from-right-4" data-id="element-1794">
              <h2 className="text-xl font-semibold text-slate-900 flex items-center gap-2" data-id="element-1795">
                <Building2 className="h-5 w-5 text-blue-600" data-id="element-1796" /> Organization
                Setup
              </h2>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-1797">
                <div data-id="element-1798">
                  <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-1799">
                    Company Logo
                  </label>
                  <div className="mt-1 flex justify-center px-6 pt-5 pb-6 border-2 border-slate-300 border-dashed rounded-lg hover:bg-slate-50 cursor-pointer transition-colors" data-id="element-1800">
                    <div className="space-y-1 text-center" data-id="element-1801">
                      <div className="mx-auto h-12 w-12 text-slate-400" data-id="element-1802">
                        <svg className="mx-auto h-12 w-12" stroke="currentColor" fill="none" viewBox="0 0 48 48" data-id="element-1803">
                          <path d="M28 8H12a4 4 0 00-4 4v20m32-12v8m0 0v8a4 4 0 01-4 4H12a4 4 0 01-4-4v-4m32-4l-3.172-3.172a4 4 0 00-5.656 0L28 28M8 32l9.172-9.172a4 4 0 015.656 0L28 28m0 0l4 4m4-24h8m-4-4v8m-12 4h.02" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-1804" />
                        </svg>
                      </div>
                      <div className="flex text-sm text-slate-600 justify-center" data-id="element-1805">
                        <span className="relative rounded-md bg-white font-medium text-blue-600 focus-within:outline-none focus-within:ring-2 focus-within:ring-blue-500 focus-within:ring-offset-2 hover:text-blue-500" data-id="element-1806">
                          Upload a file
                        </span>
                      </div>
                      <p className="text-xs text-slate-500" data-id="element-1807">
                        PNG, JPG, GIF up to 10MB
                      </p>
                    </div>
                  </div>
                </div>

                <div className="space-y-4" data-id="element-1808">
                  <div data-id="element-1809">
                    <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-1810">
                      Timezone
                    </label>
                    <div className="relative" data-id="element-1811">
                      <Clock className="absolute left-3 top-1/2 h-5 w-5 -translate-y-1/2 text-slate-400" data-id="element-1812" />
                      <select className="block w-full rounded-lg border border-slate-300 pl-10 p-2.5 focus:border-blue-500 focus:ring-blue-500" data-id="element-1813">
                        <option data-id="element-1814">(GMT-05:00) Eastern Time</option>
                        <option data-id="element-1815">(GMT-08:00) Pacific Time</option>
                        <option data-id="element-1816">(GMT+00:00) London</option>
                        <option data-id="element-1817">(GMT+01:00) Paris</option>
                      </select>
                    </div>
                  </div>

                  <div data-id="element-1818">
                    <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-1819">
                      Default Currency
                    </label>
                    <div className="relative" data-id="element-1820">
                      <Globe className="absolute left-3 top-1/2 h-5 w-5 -translate-y-1/2 text-slate-400" data-id="element-1821" />
                      <select className="block w-full rounded-lg border border-slate-300 pl-10 p-2.5 focus:border-blue-500 focus:ring-blue-500" data-id="element-1822">
                        <option data-id="element-1823">USD ($)</option>
                        <option data-id="element-1824">EUR (€)</option>
                        <option data-id="element-1825">GBP (£)</option>
                        <option data-id="element-1826">JPY (¥)</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </div>}

          {step === 2 && <div className="space-y-6 animate-in fade-in slide-in-from-right-4" data-id="element-1827">
              <h2 className="text-xl font-semibold text-slate-900 flex items-center gap-2" data-id="element-1828">
                <Users className="h-5 w-5 text-blue-600" data-id="element-1829" /> Departments
              </h2>
              <p className="text-sm text-slate-500" data-id="element-1830">
                Add departments to organize your team and budgets.
              </p>

              <div className="flex gap-2" data-id="element-1831">
                <input type="text" value={newDept} onChange={e => setNewDept(e.target.value)} placeholder="e.g. Finance" className="flex-1 rounded-lg border border-slate-300 p-2.5 focus:border-blue-500 focus:ring-blue-500" onKeyDown={e => e.key === 'Enter' && handleAddDept()} data-id="element-1832" />
                <button onClick={handleAddDept} className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 flex items-center" data-id="element-1833">
                  <Plus className="h-4 w-4 mr-1" data-id="element-1834" /> Add
                </button>
              </div>

              <div className="grid grid-cols-2 md:grid-cols-3 gap-3" data-id="element-1835">
                {departments.map(dept => <div key={dept} className="flex items-center justify-between p-3 bg-slate-50 rounded-lg border border-slate-200" data-id="element-1836">
                    <span className="font-medium text-slate-700" data-id="element-1837">{dept}</span>
                    <button onClick={() => setDepartments(departments.filter(d => d !== dept))} className="text-slate-400 hover:text-red-500" data-id="element-1838">
                      <Trash2 className="h-4 w-4" data-id="element-1839" />
                    </button>
                  </div>)}
              </div>
            </div>}

          {step === 3 && <div className="space-y-6 animate-in fade-in slide-in-from-right-4" data-id="element-1840">
              <h2 className="text-xl font-semibold text-slate-900 flex items-center gap-2" data-id="element-1841">
                <Shield className="h-5 w-5 text-blue-600" data-id="element-1842" /> Travel Policies
              </h2>
              <p className="text-sm text-slate-500" data-id="element-1843">
                Set default limits for your travelers.
              </p>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-1844">
                <div data-id="element-1845">
                  <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-1846">
                    Domestic Flight Cap
                  </label>
                  <div className="flex items-center gap-2" data-id="element-1847">
                    <span className="text-slate-500" data-id="element-1848">$</span>
                    <input type="number" className="block w-full rounded-lg border border-slate-300 p-2.5" defaultValue="500" data-id="element-1849" />
                  </div>
                </div>
                <div data-id="element-1850">
                  <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-1851">
                    International Flight Cap
                  </label>
                  <div className="flex items-center gap-2" data-id="element-1852">
                    <span className="text-slate-500" data-id="element-1853">$</span>
                    <input type="number" className="block w-full rounded-lg border border-slate-300 p-2.5" defaultValue="1500" data-id="element-1854" />
                  </div>
                </div>
                <div data-id="element-1855">
                  <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-1856">
                    Hotel Nightly Cap
                  </label>
                  <div className="flex items-center gap-2" data-id="element-1857">
                    <span className="text-slate-500" data-id="element-1858">$</span>
                    <input type="number" className="block w-full rounded-lg border border-slate-300 p-2.5" defaultValue="250" data-id="element-1859" />
                  </div>
                </div>
                <div data-id="element-1860">
                  <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-1861">
                    Advance Booking (Days)
                  </label>
                  <input type="number" className="block w-full rounded-lg border border-slate-300 p-2.5" defaultValue="14" data-id="element-1862" />
                </div>
              </div>

              <div className="flex items-center justify-between p-4 bg-slate-50 rounded-lg border border-slate-200" data-id="element-1863">
                <div data-id="element-1864">
                  <h4 className="font-medium text-slate-900" data-id="element-1865">
                    Require Approval for All Trips
                  </h4>
                  <p className="text-xs text-slate-500" data-id="element-1866">
                    If disabled, only trips exceeding budget will require
                    approval.
                  </p>
                </div>
                <label className="relative inline-flex items-center cursor-pointer" data-id="element-1867">
                  <input type="checkbox" className="sr-only peer" defaultChecked data-id="element-1868" />
                  <div className="w-11 h-6 bg-slate-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-blue-600" data-id="element-1869"></div>
                </label>
              </div>
            </div>}

          {step === 4 && <div className="space-y-6 animate-in fade-in slide-in-from-right-4" data-id="element-1870">
              <h2 className="text-xl font-semibold text-slate-900 flex items-center gap-2" data-id="element-1871">
                <Users className="h-5 w-5 text-blue-600" data-id="element-1872" /> Invite Team
              </h2>
              <p className="text-sm text-slate-500" data-id="element-1873">
                Send invitations to your colleagues.
              </p>

              <div className="flex gap-2 items-end" data-id="element-1874">
                <div className="flex-1" data-id="element-1875">
                  <label className="block text-xs font-medium text-slate-700 mb-1" data-id="element-1876">
                    Email Address
                  </label>
                  <input type="email" value={newInvite.email} onChange={e => setNewInvite({
                ...newInvite,
                email: e.target.value
              })} placeholder="colleague@company.com" className="w-full rounded-lg border border-slate-300 p-2.5 focus:border-blue-500 focus:ring-blue-500" data-id="element-1877" />
                </div>
                <div className="w-40" data-id="element-1878">
                  <label className="block text-xs font-medium text-slate-700 mb-1" data-id="element-1879">
                    Role
                  </label>
                  <select value={newInvite.role} onChange={e => setNewInvite({
                ...newInvite,
                role: e.target.value
              })} className="w-full rounded-lg border border-slate-300 p-2.5 focus:border-blue-500 focus:ring-blue-500" data-id="element-1880">
                    <option data-id="element-1881">Traveler</option>
                    <option data-id="element-1882">Manager</option>
                    <option data-id="element-1883">Finance</option>
                    <option data-id="element-1884">Admin</option>
                  </select>
                </div>
                <button onClick={handleAddInvite} className="bg-blue-600 text-white px-4 py-2.5 rounded-lg hover:bg-blue-700 flex items-center" data-id="element-1885">
                  <Plus className="h-4 w-4" data-id="element-1886" />
                </button>
              </div>

              <div className="border rounded-lg overflow-hidden" data-id="element-1887">
                <table className="min-w-full divide-y divide-slate-200" data-id="element-1888">
                  <thead className="bg-slate-50" data-id="element-1889">
                    <tr data-id="element-1890">
                      <th className="px-6 py-3 text-left text-xs font-medium text-slate-500 uppercase tracking-wider" data-id="element-1891">
                        Email
                      </th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-slate-500 uppercase tracking-wider" data-id="element-1892">
                        Role
                      </th>
                      <th className="px-6 py-3 text-right text-xs font-medium text-slate-500 uppercase tracking-wider" data-id="element-1893">
                        Action
                      </th>
                    </tr>
                  </thead>
                  <tbody className="bg-white divide-y divide-slate-200" data-id="element-1894">
                    {invites.map((invite, idx) => <tr key={idx} data-id="element-1895">
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-slate-900" data-id="element-1896">
                          {invite.email}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-slate-500" data-id="element-1897">
                          {invite.role}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium" data-id="element-1898">
                          <button onClick={() => setInvites(invites.filter((_, i) => i !== idx))} className="text-red-600 hover:text-red-900" data-id="element-1899">
                            Remove
                          </button>
                        </td>
                      </tr>)}
                  </tbody>
                </table>
              </div>
            </div>}
        </div>

        <div className="px-8 py-4 bg-slate-50 border-t border-slate-200 flex justify-between items-center" data-id="element-1900">
          <button onClick={() => step > 1 && setStep(step - 1)} disabled={step === 1} className={`flex items-center px-4 py-2 rounded-lg text-sm font-medium ${step === 1 ? 'text-slate-300 cursor-not-allowed' : 'text-slate-600 hover:bg-slate-200'}`} data-id="element-1901">
            <ArrowLeft className="mr-2 h-4 w-4" data-id="element-1902" /> Back
          </button>

          <button onClick={() => step < 4 ? setStep(step + 1) : handleComplete()} className="flex items-center px-6 py-2.5 rounded-lg bg-blue-600 text-white text-sm font-medium hover:bg-blue-700 shadow-sm" data-id="element-1903">
            {step === 4 ? 'Complete Setup' : 'Next Step'}
            {step < 4 && <ArrowRight className="ml-2 h-4 w-4" data-id="element-1904" />}
          </button>
        </div>
      </div>
    </div>;
}